import moment from 'moment-timezone';

// Formats a transfer timestamp as date + time in the user's timezone and date/time preference.
// Pass `momentDateTimeFormat` and `currUserTimezone` from useDateFormat(). Falls back to local
// time when the user has no timezone set.
export const formatTransferDateTime = (
  at: string | null | undefined,
  format: string,
  timezone?: string
) => {
  if (!at) return '';
  return (timezone ? moment.utc(at).tz(timezone) : moment(at)).format(format);
};

type TransferEntry = { is_current?: boolean } & Record<string, unknown>;

type TransferInfo = {
  history?: (number | string)[];
  applications?: Record<string, TransferEntry | undefined>;
} | null;

// Prior jobs in a transfer chain = every application except the current/live one, in chain
// (history) order. Single source for deciding single-hop vs multi-hop rendering/fetching so
// the slider header and the transferred-stages section stay consistent.
export const getPriorJobs = (transferInfo: TransferInfo | undefined) =>
  (transferInfo?.history ?? [])
    .map((appId) => ({
      appId,
      entry: transferInfo?.applications?.[String(appId)],
    }))
    .filter(({ entry }) => entry && !entry.is_current);
